export default __webpack_public_path__ + "static/media/AtTheFunctionBanner.9311083d.png";